import React from 'react'
import './Moreimg.css'

const Moreimg = () => {
  return (
    <div>
    <div className="wrapper88">
    {/* <h3>Factory Photos</h3> */}
      <div className="container88">
          <div className="hero-section88">
              <div className="gallery">
                  <div className="img-section88">
                      <img src="/images/4.jpg" alt="" />
                  </div>
                  <div className="caption88">
                      {/* <h2>Hover One</h2>
                      <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Iure, accusamus.</p> */}

                  </div>
              </div>

              <div className="gallery">
                  <div className="img-section88">
                      <img src="/images/6.jpg" alt="" />
                  </div>
                  <div className="caption88">
                      {/* <h2>Hover two</h2>
                      <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Iure, accusamus.</p> */}
                      
                  </div>
              </div>


              <div className="gallery">
                  <div className="img-section88">
                      <img src="/images/4.jpg" alt="" />
                  </div>
                  <div className="caption88">
                      {/* <h2>Hover three</h2>
                      <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Iure, accusamus.</p> */}
                      
                  </div>
              </div>


              <div className="gallery">
                  <div className="img-section88">
                      <img src="/images/6.jpg" alt="" />
                  </div>
                  <div className="caption88">
                      {/* <h2>Hover four</h2>
                      <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Iure, accusamus.</p> */}
                      
                  </div>
              </div>



              <div className="gallery">
                  <div className="img-section88">
                      <img src="/images/4.jpg" alt="" />
                  </div>
                  <div className="caption88">
                      {/* <h2>Hover five</h2>
                      <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Iure, accusamus.</p> */}
                      
                  </div>
              </div>


              <div className="gallery">
                  <div className="img-section88">
                      <img src="/images/6.jpg" alt="" />
                  </div>
                  <div className="caption88">
                      {/* <h2>Hover six</h2>
                      <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Iure, accusamus.</p> */}
                      
                  </div>
              </div>



              <div className="gallery">
                  <div className="img-section88">
                      <img src="/images/4.jpg" alt="" />
                  </div>
                  <div className="caption88">
                      {/* <h2>Hover One</h2>
                      <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Iure, accusamus.</p> */}

                  </div>
              </div>

              <div className="gallery">
                  <div className="img-section88">
                      <img src="/images/6.jpg" alt="" />
                  </div>
                  <div className="caption88">
                      {/* <h2>Hover two</h2>
                      <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Iure, accusamus.</p> */}
                      
                  </div>
              </div>


              <div className="gallery">
                  <div className="img-section88">
                      <img src="/images/4.jpg" alt="" />
                  </div>
                  <div className="caption88">
                      {/* <h2>Hover three</h2>
                      <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Iure, accusamus.</p> */}
                      
                  </div>
              </div>


              <div className="gallery">
                  <div className="img-section88">
                      <img src="/images/6.jpg" alt="" />
                  </div>
                  <div className="caption88">
                      {/* <h2>Hover four</h2>
                      <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Iure, accusamus.</p>
                       */}
                  </div>
              </div>



              <div className="gallery">
                  <div className="img-section88">
                      <img src="/images/4.jpg" alt="" />
                  </div>
                  <div className="caption88">
                      {/* <h2>Hover five</h2>
                      <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Iure, accusamus.</p> */}
                      
                  </div>
              </div>


              <div className="gallery">
                  <div className="img-section88">
                      <img src="/images/6.jpg" alt="" />
                     
                  </div>
                  <div className="caption88">
                      {/* <h2>Hover six</h2>
                      <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Iure, accusamus.</p> */}
                      
                  </div>
              </div>



          </div>
      </div>
    </div>


  </div>
  )
}

export default Moreimg
